import React from 'react';
import { useDispatch } from 'react-redux';
import AccessibleDiv from 'components/AccessibleDiv/AccessibleDiv';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import { ModalType } from 'const';
import { showModal } from 'containers/ModalManager/actions';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

type Props = {
  dataTestId?: string;
};

const ImageBoxItem: React.FC<Required<Props>> = ({ dataTestId }) => {
  const dispatch = useDispatch();
  const showAddImageModalWindowHandler = (): void => {
    dispatch(showModal(ModalType.ADD_IMAGE));
  };

  return (
    <AccessibleDiv className={styles.box} onClick={showAddImageModalWindowHandler} data-testid={`${dataTestId}-button`}>
      <div className={styles['box__icon-add']}>
        <Icon type={IconType.PLUS_FILLED} size="md" color="primary" />
      </div>
      <div className={styles.box__icon}>
        <Icon type={IconType.IMAGE} size="lg" color="light-grey" />
      </div>
    </AccessibleDiv>
  );
};

const AddImageItem: React.FC<Props> = ({ dataTestId = 'addImage' }) => {

  return (
    <li className={styles.AddImageItemWrapper} data-testid={dataTestId}>
      <div className={styles.AddImageItem}>
        <ImageBoxItem dataTestId={dataTestId}/>
        <div className={styles.info} data-testid={`${dataTestId}-text`}>{intlGet('ImagesList', 'AddImage')}</div>
      </div>
    </li>
  );

};

export default AddImageItem;
